import React from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';

import InputTextArea from 'components/form/InputTextArea';
import Form from 'components/form-multi/Form';

import { AUTH_PAY_NOTIFICATION_ACTION } from 'constants/UrlConstants';
import { USA } from 'constants/WellKnownCountries';

import { Button } from '../../common/Button/Button';
import { FixedBottomPanel } from '../../common/Layout/FixedBottomPanel/FixedBottomPanel';
import { HeaderPanel } from '../../common/Layout/HeaderPanel/HeaderPanel';
import { Row } from '../../common/Layout/Row';
import InputPhoneWithDropdown from '../../form/InputPhoneWithDropdown';
import ModalComponent from '../../utils/ModalComponent';

const SendSMS = (props) => {
    const fields = props.forms[props.formName]?.fields;
    return (
        <ModalComponent>
            <HeaderPanel
                title={props.userCountryId === USA ? props.sendUsaSmsHeaderTitle : props.sendSmsHeaderTitle}
                subtitle={props.userCountryId === USA ? props.sendUsaTransferName : props.sendTransferName}
            />
            <Form formName={props.formName} action={AUTH_PAY_NOTIFICATION_ACTION}>
                <Row indent="adaptive-32-48">
                    <InputPhoneWithDropdown
                        field={fields?.phone}
                        formName={props.formName}
                        defaultCountry={props.defaultCountry}
                        iso2={props.defaultCountry}
                        isNonEditableCountry
                    />
                </Row>
                <InputTextArea field={fields?.text} formName={props.formName} isNewInput />
                <FixedBottomPanel isRightAligned>
                    <Button type="submit" raised={true} caption={props.sendSmsButton} />
                </FixedBottomPanel>
            </Form>
        </ModalComponent>
    );
};

SendSMS.propTypes = {
    formName: PropTypes.string.isRequired,
};

const mapStateToProps = (state) => {
    return {
        userCountryId: state.auth.countryId,
        forms: state.form,
        sendSmsButton: state.messages.pageMessages.sendSmsButton,
        sendSmsHeaderTitle: state.messages.pageMessages.sendSmsHeaderTitle,
        sendUsaSmsHeaderTitle: state.messages.pageMessages.sendUsaSmsHeaderTitle,
        sendTransferName: state.messages.pageMessages.sendTransferName,
        sendUsaTransferName: state.messages.pageMessages.sendUsaTransferName,
        defaultCountry: state.extra.defaultCountry,
    };
};
export default connect(mapStateToProps, null)(SendSMS);
